import { DropdownMenuItem } from "@workspace/frontend-ui";
import type { FC } from "react";
import SidebarIcon from "../../Sidebar/SidebarView/SidebarSection/SidebarIcon";
import { dispatchProfileLogout } from "./profileLogoutEvent";
import type { ProfileMenuEntry } from "./types";

type Props = {
  item: ProfileMenuEntry;
};

const ProfileLogoutItem: FC<Props> = ({ item }) => {
  const handleLogout = () => {
    dispatchProfileLogout();
  };

  return (
    <DropdownMenuItem
      onSelect={handleLogout}
      className="cursor-pointer gap-3 rounded-lg px-2.5 py-2.5"
    >
      <SidebarIcon icon={item.icon} hugeIcon={item.hugeIcon} />
      <span className="flex-1 truncate font-medium text-foreground text-sm">
        {item.label}
      </span>
    </DropdownMenuItem>
  );
};

export default ProfileLogoutItem;
